<template>
  <div class="carousel-with-pages">
    <div class="dot-container">
      <span
          v-for="(route, index) in routes"
          :key="index"
          :class="{ active: currentRoute === route.path }"
          @click="handleClick(route.path)"
      >
      </span>
    </div>
  </div>
</template>

<script>
import MainContent from "@/components/MainContentPage.vue";
import Services from "@/components/ServicesPage.vue";
import Resources from "@/components/ResourcesPage.vue";
import Team from "@/components/TeamPage.vue";
import Testimonials from "@/components/TestimonialsPage.vue";
import Contact from "@/components/ContactPage.vue";

export default {
  data() {
    return {
      routes: [
        {
          path: '/main_content',
          name: 'MainContentPage',
          component: MainContent
        },
        {
          path: '/services',
          name: 'ServicesPage',
          component: Services
        },
        {
          path: '/resources',
          name: 'ResourcesPage',
          component: Resources
        },
        {
          path: '/team',
          name: 'TeamPage',
          component: Team
        },
        {
          path: '/testimonials',
          name: 'TestimonialsPage',
          component: Testimonials
        },
        {
          path: '/contact',
          name: 'ContactPage',
          component: Contact
        }
      ],
      currentRoute: this.$route.path
    };
  },
  watch: {
    $route(to) {
      this.currentRoute = to.path;
    }
  },
  methods: {
    handleClick( key ) {
      this.selectedKeys = [key];
      this.$router.push(key);
      const targetSection = document.getElementById(key.slice(1));
      console.log(key.slice(1),targetSection);
      if (targetSection) {
        const headerHeight = document.querySelector('.header').offsetHeight;
        const targetPosition = targetSection.offsetTop - headerHeight;
        this.smoothScroll(targetPosition, 1000); // 1000ms为滚动时间，可调整
      }
    },
    smoothScroll(targetY, duration) {
      const startY = window.pageYOffset;
      const distance = targetY - startY;
      let startTime = new Date().getTime();
      const interval = setInterval(() => {
        const currentTime = new Date().getTime();
        const elapsed = currentTime - startTime;
        const progress = elapsed / duration;
        if (progress >= 1) {
          window.scrollTo(0, targetY);
          clearInterval(interval);
        } else {
          window.scrollTo(0, startY + (distance * progress));
        }
      }, 16); // 大约每秒60帧（1000/60 ≈ 16）
    },
  }
};
</script>

<style scoped lang="less">
@mainColorBrown: #a37e71;
@mainColorPink: #e89dab;
@mainColorPinkLight: #f4c6cc;
.carousel-with-pages {
  width: 100%;
  position: relative;
}
@media screen and (max-width: 768px) {
  .carousel-with-pages {
    .dot-container {
      display: none;
    }
  }
}
.carousel-content {
  width: 100%;
  height: 100vh; // 假设页面高度占满视口高度，可根据实际调整
  overflow: hidden;
  position: relative;
}

.dot-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.dot-container span {
  width: 10px;
  height: 10px;
  box-sizing: border-box;
  border-radius: 50%;
  background-color: @mainColorBrown;
  border: 2px solid transparent;
  box-shadow: 0 0 0 1px transparent;
  margin: 10px 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  color: white;
  font-size: 12px;
  text-align: center;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: @mainColorPinkLight;
    border: 2px solid white;
    box-shadow: 0 0 0 1px @mainColorPinkLight;
  }

  &.active {
    background-color: @mainColorPinkLight;
    border: 2px solid white;
    box-shadow: 0 0 0 1px @mainColorPinkLight;
  }
}
</style>